import React from 'react';
import { motion } from 'framer-motion';
import { Plus, RefreshCw, Shield, Clock } from 'lucide-react';

interface ActivityItem {
  action: string;
  target: string;
  time: string;
  icon: React.ComponentType<any>;
  color: string;
}

const RecentActivity: React.FC = () => {
  const activities: ActivityItem[] = [
    {
      action: 'Zone created',
      target: 'example.com',
      time: '2 minutes ago',
      icon: Plus,
      color: 'text-green-600',
    },
    {
      action: 'Provider synced',
      target: 'Cloudflare',
      time: '5 minutes ago',
      icon: RefreshCw,
      color: 'text-blue-600',
    },
    {
      action: 'Records updated',
      target: 'api.example.com',
      time: '1 hour ago',
      icon: Shield,
      color: 'text-purple-600',
    },
  ];

  return (
    <motion.div
      className="card"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.5 }}
    >
      <div className="card-header">
        <div className="flex items-center justify-between">
          <h2 className="text-heading-1 text-slate-900 dark:text-white">Recent Activity</h2>
          <button className="text-body-small text-blue-600 hover:text-blue-700 font-medium">
            View all
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="space-y-4">
          {activities.map((activity, index) => (
            <motion.div
              key={index}
              className="flex items-start space-x-3 p-3 rounded-lg hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-colors cursor-pointer group"
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.6 + index * 0.1 }}
            >
              <div
                className={`w-8 h-8 rounded-lg bg-slate-100 dark:bg-slate-800 flex items-center justify-center ${activity.color} group-hover:scale-105 transition-transform`}
              >
                <activity.icon className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-body font-medium text-slate-900 dark:text-white">
                  {activity.action}
                </p>
                <p className="text-body-small text-slate-600 dark:text-slate-400 truncate">
                  {activity.target}
                </p>
              </div>
              <div className="flex items-center space-x-2 text-body-small text-slate-500 dark:text-slate-400">
                <Clock className="w-3 h-3" />
                <span>{activity.time}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-6 pt-4 border-t border-slate-200 dark:border-slate-700">
          <p className="text-body-small text-slate-500 dark:text-slate-400 text-center">
            Real-time activity monitoring • Updated every 30 seconds
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default RecentActivity;
